import { PropsWithClassName, cn } from "kz-ui-sdk";
import MegaShareFAB from "./MegaShareFAB";

interface MegaShareProps extends PropsWithClassName {
  className?: string;
  fabClassName?: string;
  onClick: () => void;
}

const MegaShare = ({ className, fabClassName, onClick }: MegaShareProps) => {
  return (
    <div className={cn(className)}>
      <MegaShareFAB
        className={cn(fabClassName)}
        zIndex={20}
        aria-label="Mega Share Animation"
        onClick={onClick}
      />
    </div>
  );
};

export default MegaShare;
